import mitt, { type Emitter } from 'mitt';
import type { EventBusEvents } from '@/utils/useEventBus/types';

const emitter = mitt<EventBusEvents>();

export const useEventBus = (): Emitter<EventBusEvents> => {
  return emitter;
};
